import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchTracks = createAsyncThunk('tracks/fetchAll', async (_, { rejectWithValue }) => {
  try {
    const res = await api.get('/tracks');
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Erro ao buscar trilhas');
  }
}, {
  // A lista e pedida por mais de um componente montado ao mesmo tempo (a Sidebar
  // precisa dela para a badge, a pagina precisa dela para o conteudo). Sem este
  // guarda, abrir o Inicio dispara dois GET /tracks identicos no mesmo instante.
  condition: (_, { getState }) => !getState().tracks.loading,
});

export const fetchTrack = createAsyncThunk('tracks/fetchOne', async (id, { rejectWithValue }) => {
  try {
    const res = await api.get(`/tracks/${id}`);
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Trilha não encontrada');
  }
});

export const enrollTrack = createAsyncThunk('tracks/enroll', async (id, { rejectWithValue }) => {
  try {
    await api.post(`/tracks/${id}/enroll`);
    return id;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Erro ao matricular');
  }
});

const tracksSlice = createSlice({
  name: 'tracks',
  initialState: {
    list: [],
    current: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearCurrent: (state) => { state.current = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTracks.pending, (state) => { state.loading = true; })
      .addCase(fetchTracks.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchTracks.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(fetchTrack.pending, (state) => { state.loading = true; state.current = null; })
      .addCase(fetchTrack.fulfilled, (state, action) => { state.loading = false; state.current = action.payload; })
      .addCase(fetchTrack.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(enrollTrack.fulfilled, (state, action) => {
        const track = state.list.find((t) => t.id === action.payload);
        if (track) track.enrolled = true;
        if (state.current?.id === action.payload) state.current.enrolled = true;
      });
  },
});

export const { clearCurrent } = tracksSlice.actions;
export default tracksSlice.reducer;
